module.exports = __webpack_public_path__ + "static/media/scr_simple_numeric_keypad.b475a8f5.png";